export default __webpack_public_path__ + "static/char-v-29-ada651e8f63487017845058547f7f4c6.webp";